"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchRoute
 * @description Baasic Notifications Registrations Users Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var NotificationsRegistrationsUsersBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersBatchRoute, _super);
    function NotificationsRegistrationsUsersBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/user/batch';
        _this.deleteRoute = 'notifications/registrations/user/batch';
        _this.updateRoute = 'notifications/registrations/user/batch';
        return _this;
    }
    /**
     * Parses create users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.create();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses remove users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.delete();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.update();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.update = function () {
        return this.baseUpdate(this.updateRoute, {});
    };
    var _a;
    NotificationsRegistrationsUsersBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsUsersBatchRoute);
    return NotificationsRegistrationsUsersBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersBatchRoute = NotificationsRegistrationsUsersBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
